// extracted by mini-css-extract-plugin
export default {"container":"ErrorLayout_container__vHQzJ","illustration":"ErrorLayout_illustration__IEksw","title":"ErrorLayout_title__6ZhgY"};